'use client'

/**
 * Simple mobile title bar for settings. Tab navigation (Profile, Edit Profile, etc.)
 * lives in the site side menu (drawer), not in this header, so the site hamburger is used.
 */

export function MobileProfileHeader() {
  return (
    <div className="lg:hidden">
      <div className="flex items-center justify-between p-4 border-b border-border bg-background-secondary">
        <h1 className="text-lg font-semibold text-foreground-default">Settings</h1>
      </div>
    </div>
  )
}